import { j as G, r as Qe } from "./jsx-runtime-3tyXYecC.mjs";
import ie, { forwardRef as Ye, useRef as X, useState as ee, useLayoutEffect as Je } from "react";
import { T as Xe } from "./text-field-ZOMRKQAY.mjs";
import { f as et, A as Re, o as Ie, B as tt, u as nt, E as rt, F as pe, t as at, G as ot, H as Y, I as te, J as it } from "./date-picker-utils-provider-CwC1AjFc.mjs";
import { w as st } from "./sizes-DktS74Qp.mjs";
import { f as S } from "./index-LyFokDcn.mjs";
import { m as ct } from "./tss-DN0acMKN.mjs";
import { P as ut } from "./picker-button-Cfkqdcrg.mjs";
import { _ as Te } from "./composeRefs-YONvD-rx.mjs";
import { I as lt } from "./InputAdornment-T4xPPRnD.mjs";
import { B as ft } from "./ButtonBase-BIvHZGlt.mjs";
import { a as Me, g as dt } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { p as vt } from "./index-BpaEWJM0.mjs";
const Ae = (t) => ie.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 15 16", width: "15", height: "16" }, t),
  ie.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    ie.createElement(
      "g",
      { fillRule: "nonzero" },
      ie.createElement("path", { d: "M623.666667,645 C624.402667,645 625,645.597333 625,646.333333 L625,648 L610,648 L610,646.333333 C610,645.597333 610.596667,645 611.333333,645 L623.666667,645 Z M610,659.736842 L610,649 L625,649 L625,659.736842 C625,660.434105 624.403333,661 623.666667,661 L611.333333,661 C610.597333,661 610,660.434737 610,659.736842 Z M612,651 L612,653 L614,653 L614,651 L612,651 Z M612,654 L612,656 L614,656 L614,654 L612,654 Z M612,657 L612,659 L614,659 L614,657 L612,657 Z M615,651 L615,653 L617,653 L617,651 L615,651 Z M615,654 L615,656 L617,656 L617,654 L615,654 Z M615,657 L615,659 L617,659 L617,657 L615,657 Z M618,651 L618,653 L620,653 L620,651 L618,651 Z M618,654 L618,656 L620,656 L620,654 L618,654 Z M618,657 L618,659 L620,659 L620,657 L618,657 Z M621,651 L621,653 L623,653 L623,651 L621,651 Z M621,654 L621,656 L623,656 L623,654 L621,654 Z", transform: "translate(-610 -645)" })
    )
  )
);
Ae.displayName = "Calendar15x16";
function gn(t, e) {
  const a = e.relatedTarget;
  return t.some((r) => r.contains(a));
}
function fe(t) {
  return t.order.map((a) => t.parts[a].mask).join(t.delimiterChar);
}
function pt(t, e, a, r) {
  let n = "", i = a, o = r, u = !1;
  const l = t.delimiterChar, d = e.split("");
  return d.forEach((p, b) => {
    const h = d[b + 1];
    u ? p === l && h === l ? (b < a && i--, b < r && o--) : p === l && h === void 0 ? (b < a && (i = b), b < r && (o = b)) : n = `${n}${p}` : p === l ? (b < a && i--, b < r && o--) : (n = `${n}${p}`, u = !0);
  }), {
    endPosition: o,
    inputValue: n,
    startPosition: i
  };
}
function ht(t, e, a, r, n, i) {
  const o = t.delimiterChar;
  if (r.split(o).length > t.order.length && be(e, a) === "point") {
    const d = ue(r, o), b = d.map(
      (h) => he(h, n, i)
    ).findIndex((h) => (h == null ? void 0 : h.startIndex) === 0);
    if (b > -1) {
      const h = d[b].startIndex - 1, E = r.split("");
      E.splice(h, 1), r = E.join(""), h < n && n--, h < i && i--;
    }
  }
  return {
    endPosition: i,
    inputValue: r,
    startPosition: n
  };
}
function mt(t, e, a, r, n, i, o) {
  const u = be(a, r), l = n.length - e.length, d = t.delimiterChar, p = bt(
    t,
    e,
    a,
    r,
    n,
    i,
    o
  ), b = yt(p), h = gt(b, u, l), E = wt(h, d), w = Ft(E), P = Tt(w), L = kt(P);
  return Ot(L);
}
function bt(t, e, a, r, n, i, o) {
  const u = fe(t), l = t.delimiterChar, d = n.split(l), p = u.split(l), b = ue(e, l), h = ue(n, l), E = e.split(l);
  return t.order.map((w, P) => {
    const L = t.parts[w], C = p[P], V = E[P], K = b[P], H = he(K, a, r), Z = h[P], q = he(Z, i, o), { match: N, matcher: M, matchComplete: A } = je(V, V, C, L.matchers), R = N ? N[0] : "";
    return {
      config: L,
      inputIndexes: Z,
      inputRelativeCursorIndexes: q,
      inputValue: d[P],
      keydownIndexes: K,
      keydownMatch: N,
      keydownMatchComplete: A,
      keydownMatchedValue: R,
      keydownMatcher: M,
      keydownRelativeCursorIndexes: H,
      keydownValue: V,
      maskValue: C
    };
  });
}
function yt(t) {
  return t.map((e) => {
    const { inputValue: a, keydownValue: r, maskValue: n } = e;
    return a && r === n ? {
      ...e,
      demaskedValue: a.replace(n, "")
    } : {
      ...e,
      demaskedValue: a
    };
  });
}
function gt(t, e, a) {
  return t.map((r) => {
    const { demaskedValue: n, inputRelativeCursorIndexes: i } = r;
    if ((i == null ? void 0 : i.startIndex) !== void 0 && e === "point" && a === 1 && n) {
      const o = n.split("");
      o.splice(i.startIndex, 1);
      const u = o.join("");
      return {
        ...r,
        isOvertyped: !0,
        overtypedValue: u
      };
    }
    return {
      ...r,
      isOvertyped: !1,
      overtypedValue: n
    };
  });
}
function wt(t, e) {
  const a = t.map((u) => u.overtypedValue).filter((u) => u !== void 0);
  if (a.length === t.length)
    return t.map((u) => ({
      ...u,
      resolvedValue: u.overtypedValue
    }));
  let r = a.join(e);
  const n = t.map((u) => {
    const { keydownValue: l } = u;
    if (r.includes(l))
      return r = r.replace(l, ""), l;
  });
  if (n.every((u) => u !== void 0))
    return t.map((u, l) => ({
      ...u,
      resolvedValue: n[l]
    }));
  let i = r.split(e);
  i = i.filter((u) => u !== "");
  const o = n.map((u) => u !== void 0 ? u : i.length ? i.shift() : "");
  return t.map((u, l) => ({
    ...u,
    resolvedValue: o[l]
  }));
}
function Ft(t) {
  return t.map((e) => {
    const { config: a, resolvedValue: r } = e, { preMatchHook: n } = a;
    let i = r;
    return n && (i = n(i)), {
      ...e,
      preMatchHookValue: i,
      changedByPreMatchHook: r !== i
    };
  });
}
function Tt(t) {
  return t.map((e) => {
    const { config: a, preMatchHookValue: r, keydownValue: n, maskValue: i } = e, { match: o, matcher: u, matchComplete: l } = je(r, n, i, a.matchers), d = o ? o[0] : "";
    return {
      ...e,
      matchedValue: d,
      match: o,
      matcher: u,
      matchComplete: l,
      rejectedLength: r.length - d.length
    };
  });
}
function kt(t) {
  return t.map((e) => {
    let { matchedValue: a } = e;
    const { config: r, maskValue: n } = e, { mask: i } = r;
    return e.matcher && e.matcher.fixedLength && (a = Ve(a, i)), a || (a = n), {
      ...e,
      conformedValue: a
    };
  });
}
function Ot(t) {
  return t.map((e) => ({
    ...e,
    changed: e.keydownValue !== e.conformedValue,
    changeAttempted: e.keydownValue !== e.inputValue
  }));
}
function Dt(t, e, a) {
  const r = t.delimiterChar, n = ue(a, r);
  return e.map((i, o) => ({
    ...i,
    finalValueIndexes: n[o]
  }));
}
function ue(t, e) {
  const a = t.split(""), r = [];
  let n = {
    endIndex: 0,
    // temporary placeholder
    startIndex: 0
  };
  return a.forEach((i, o) => {
    o === a.length - 1 ? (n.endIndex = o, r.push(n)) : i === e && (n.endIndex = o - 1, r.push(n), n = {
      endIndex: 0,
      // temporary placeholder
      startIndex: o + 1
    });
  }), r;
}
function he(t, e, a) {
  let r, n;
  if (t && (e >= t.startIndex && e <= t.endIndex && (r = e - t.startIndex), a >= t.startIndex && a <= t.endIndex && (n = a - t.startIndex)), r !== void 0 || n !== void 0)
    return {
      startIndex: r,
      endIndex: n
    };
}
function je(t, e, a, r) {
  e === a && (t = t.replace(a, ""));
  let n, i, o = !1;
  return r.forEach((u) => {
    const l = u.regex.exec(t);
    if (l && (!n || l[0].length > n[0].length && l.index <= n.index)) {
      n = l, i = u;
      const d = i.fixedLength || i.maxLength;
      o = n[0].length === d;
    }
  }), {
    match: n,
    matcher: i,
    matchComplete: o
  };
}
function ke(t, e, a, r) {
  return (t ? t.matchComplete : !0) && e[a] === r && (a += 1), a;
}
function be(t, e) {
  return t === e ? "point" : "selection";
}
function Et(t, e, a, r, n, i, o, u) {
  var E;
  const l = t.delimiterChar, d = i.length - a.length;
  if (be(r, n) === "point" && d === -1)
    return o;
  const h = Dt(t, e, u).filter((w) => w.changeAttempted);
  if (h.length) {
    const w = Pt(h);
    let P;
    return Ct(w) ? P = (((E = w.finalValueIndexes) == null ? void 0 : E.startIndex) || 0) + w.matchedValue.length : P = o, ke(w, u, P, l);
  }
  return ke(void 0, u, r, l);
}
function Pt(t) {
  let e = t[t.length - 1];
  const a = t.filter((r) => !r.matchComplete);
  return a.length && ([e] = a), e;
}
function Ct(t) {
  return t.changedByPreMatchHook || t.keydownMatchComplete && !t.matchComplete || t.rejectedLength ? !0 : t.matchedValue && t.keydownMatchedValue ? t.matchedValue.length < t.keydownMatchedValue.length : !!(t.matchedValue || t.keydownMatchedValue);
}
function Ve(t, e) {
  if (t.length < e.length) {
    const a = e.slice(t.length - e.length);
    return `${t}${a}`;
  }
  return t;
}
function Lt(t, e) {
  const a = fe(t), r = t.delimiterChar;
  let n = e.map((i) => i.conformedValue).join(r);
  return n === a && (n = ""), n;
}
function xt(t, e, a, r, n, i, o) {
  if ({ endPosition: i, inputValue: o, startPosition: n } = pt(t, o, n, i), !r) {
    const p = fe(t);
    r = p, e = 0, a = o.length, o = Ve(o, p);
  }
  ({ endPosition: i, inputValue: o, startPosition: n } = ht(
    t,
    e,
    a,
    o,
    n,
    i
  ));
  const u = mt(
    t,
    r,
    e,
    a,
    o,
    n,
    i
  ), l = Lt(t, u);
  return {
    position: Et(
      t,
      u,
      r,
      e,
      a,
      o,
      n,
      l
    ),
    value: l
  };
}
function Nt(t, e, a, r) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  return r ? a : Be(t, e) || a;
}
function Be(t, e) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  if (!e || !et(t, e))
    return;
  const a = t.format(e, "fullDate");
  if (t.formats.fullDate === "dd MMM yyyy" && a) {
    const n = a.split(" "), i = n[1].toLowerCase(), l = Re(t).map((d) => d.toLowerCase()).indexOf(i);
    if (l > -1) {
      const p = Ie(t)[l];
      p && n.splice(1, 1, p);
    }
    return n.join(" ");
  }
  return a;
}
function Oe(t, e) {
  return {
    inputValue: e,
    value: t
  };
}
function De(t, e) {
  if (!t)
    throw new Error("Expected arguments are missing.");
  const a = t.formats.fullDate;
  if (a === "dd MMM yyyy" && e) {
    const r = e.split(" "), n = r[1].toLowerCase(), u = Ie(t).map((l) => l.toLowerCase()).indexOf(n);
    if (u > -1) {
      const d = Re(t)[u];
      d && r.splice(1, 1, d);
    }
    e = r.join(" ");
  }
  return tt(t, a, e);
}
function Ee(t, e) {
  const a = Be(t, e);
  return a ? window.jQuery ? $.__("Pick a date. The current value is %1$s.", a) : `Pick a date. The current value is ${a}.` : window.jQuery ? $.__("Pick a date.") : "Pick a date.";
}
const Rt = ct()((t, e) => {
  const { mixins: a, palette: r, typography: n } = t, { disabled: i, noteStatus: o } = e, u = () => o === "error" ? r.error.main : o === "warning" ? r.warning.main : o === "info" ? r.info.main : r.gray[700];
  return {
    iconButton: {
      fill: i ? r.gray[400] : r.primary.main,
      height: "100%",
      width: 27,
      // @startCleanup encore
      "&:focus": {
        border: S.ifFeature("encore", void 0, a.border(1, r.primary.lighter)),
        borderRadius: S.ifFeature("encore", void 0, 2),
        boxShadow: S.ifFeature("encore", void 0, `0 0 0 2px ${a.alpha(r.primary.lightest, 0.35)}`)
      }
      // @endCleanup encore
    },
    note: {
      alignItems: "center",
      color: u(),
      display: "flex",
      fontSize: n.fabricFontSize("teenie"),
      height: 34,
      lineHeight: n.fabricLineHeight("teenie"),
      marginLeft: 8
    },
    root: {
      alignItems: "flex-end",
      display: "flex",
      minWidth: S.ifFeature("encore", void 0, st[5])
    }
  };
}), wn = Ye(
  ({
    afterLabel: t,
    ariaDescribedby: e,
    biId: a,
    className: r,
    calendarButtonRef: n,
    calendarId: i,
    classes: o = {},
    disabled: u = !1,
    errorMessage: l,
    id: d,
    inputProps: p = {},
    isPopoverOpen: b,
    label: h,
    labelPlacement: E,
    note: w,
    notePlacement: P,
    noteStatus: L,
    onBlur: C,
    onChange: V,
    onInputChange: K,
    onPopupToggle: H,
    popupToggleButtonProps: Z,
    required: q = !1,
    size: N,
    status: M = "default",
    value: A,
    variant: R = "form",
    viewMode: g = !1,
    warningMessage: c,
    width: s = S.ifFeature("encore", 6, 5)
  }, f) => {
    L = L || M;
    const y = {
      disabled: u,
      noteStatus: L,
      size: N
    }, { classes: m, cx: T } = Rt(y), F = nt(), O = X(null), D = X(null), I = X(0), B = X(0), x = X(""), _ = rt(F), [z, W] = ee(!1), [Q, ge] = ee(""), [de, Se] = ee(0), [Ke, $e] = ee(0), [He, ve] = ee(!0);
    return Je(() => {
      var k;
      (k = O.current) == null || k.setSelectionRange(de, de);
    }, [de, Ke]), /* @__PURE__ */ G.jsxs("div", { className: T(m.root, r, o.root), ref: f, children: [
      /* @__PURE__ */ G.jsx(
        Xe,
        {
          afterLabel: t,
          ariaDescribedby: e,
          biId: a && `${a}_input`,
          classes: {
            note: m.note
          },
          disabled: u,
          errorMessage: l,
          focusRing: He,
          id: d,
          inputProps: {
            ...p,
            onKeyDown: qe
          },
          InputProps: {
            denseAdornment: !0,
            endAdornment: !g && S.ifFeature(
              "encore",
              /* @__PURE__ */ G.jsx(
                ut,
                {
                  ariaControls: b ? `date-picker-control-${i}` : void 0,
                  ariaExpanded: b ? "true" : "false",
                  ariaHaspopup: "dialog",
                  ariaLabel: Ee(F, A),
                  containerRef: Te(D, n),
                  disabled: u,
                  icon: "calendar-regular",
                  onBlur: Fe,
                  onClick: H,
                  onFocus: () => {
                    ve(!1);
                  },
                  size: N,
                  status: M === "default" ? void 0 : M,
                  variant: R
                }
              ),
              /* @__PURE__ */ G.jsx(lt, { position: "end", children: /* @__PURE__ */ G.jsx(
                ft,
                {
                  "aria-controls": b ? `date-picker-control-${i}` : void 0,
                  "aria-expanded": b ? "true" : "false",
                  "aria-haspopup": "dialog",
                  "aria-label": Ee(F, A),
                  ...Z,
                  className: m.iconButton,
                  disabled: u,
                  onBlur: Fe,
                  onClick: H,
                  onFocus: () => ve(!1),
                  ref: n,
                  children: /* @__PURE__ */ G.jsx(Ae, {})
                }
              ) })
            )
          },
          label: h,
          labelPlacement: E,
          note: S.ifFeature("encore", w),
          notePlacement: P,
          onBlur: Ze,
          onChange: Ge,
          placeholder: fe(_),
          ref: Te(O, p.ref),
          required: q,
          size: N,
          status: M === "default" ? void 0 : M,
          value: Nt(F, A, Q, z),
          variant: R,
          viewMode: g,
          warningMessage: c,
          width: s
        }
      ),
      S.ifFeature(
        "encore",
        null,
        w && /* @__PURE__ */ G.jsx("div", { className: m.note, "data-test-id": "note", children: w })
      )
    ] });
    function we(k) {
      const { relatedTarget: U } = k;
      return !!U && [O.current, D.current].some((j) => j == null ? void 0 : j.contains(U));
    }
    function Ze(k) {
      z && Ue(Q), W(!1), p.onBlur && p.onBlur(k), typeof C == "function" && !we(k) && C(k);
    }
    function Fe(k) {
      ve(!0), typeof C == "function" && !we(k) && C(k);
    }
    function Ue(k) {
      const U = De(F, k);
      U && ge("");
      const j = Oe(U, k);
      V(j);
    }
    function Ge(k) {
      z || W(!0);
      const { position: U, value: j } = xt(
        _,
        I.current,
        B.current,
        x.current,
        k.target.selectionStart,
        k.target.selectionEnd,
        k.target.value
      ), ze = De(F, j);
      ge(j), Se(U), $e((We) => We + 1), typeof K == "function" && K(Oe(ze, j)), p.onChange && p.onChange(k);
    }
    function qe(k) {
      I.current = k.currentTarget.selectionStart, B.current = k.currentTarget.selectionEnd, x.current = k.currentTarget.value, p.onKeyDown && p.onKeyDown(k);
    }
  }
);
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Pe(t, e) {
  var a = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), a.push.apply(a, r);
  }
  return a;
}
function Ce(t) {
  for (var e = 1; e < arguments.length; e++) {
    var a = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pe(Object(a), !0).forEach(function(r) {
      It(t, r, a[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(a)) : Pe(Object(a)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(a, r));
    });
  }
  return t;
}
function It(t, e, a) {
  return e = At(e), e in t ? Object.defineProperty(t, e, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = a, t;
}
function Mt(t, e) {
  if (typeof t != "object" || t === null) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var r = a.call(t, e || "default");
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function At(t) {
  var e = Mt(t, "string");
  return typeof e == "symbol" ? e : String(e);
}
var Le = {
  activateTrap: function(e, a) {
    if (e.length > 0) {
      var r = e[e.length - 1];
      r !== a && r.pause();
    }
    var n = e.indexOf(a);
    n === -1 || e.splice(n, 1), e.push(a);
  },
  deactivateTrap: function(e, a) {
    var r = e.indexOf(a);
    r !== -1 && e.splice(r, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, jt = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Vt = function(e) {
  return (e == null ? void 0 : e.key) === "Escape" || (e == null ? void 0 : e.key) === "Esc" || (e == null ? void 0 : e.keyCode) === 27;
}, oe = function(e) {
  return (e == null ? void 0 : e.key) === "Tab" || (e == null ? void 0 : e.keyCode) === 9;
}, Bt = function(e) {
  return oe(e) && !e.shiftKey;
}, _t = function(e) {
  return oe(e) && e.shiftKey;
}, xe = function(e) {
  return setTimeout(e, 0);
}, Ne = function(e, a) {
  var r = -1;
  return e.every(function(n, i) {
    return a(n) ? (r = i, !1) : !0;
  }), r;
}, ne = function(e) {
  for (var a = arguments.length, r = new Array(a > 1 ? a - 1 : 0), n = 1; n < a; n++)
    r[n - 1] = arguments[n];
  return typeof e == "function" ? e.apply(void 0, r) : e;
}, se = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, St = [], Kt = function(e, a) {
  var r = (a == null ? void 0 : a.document) || document, n = (a == null ? void 0 : a.trapStack) || St, i = Ce({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Bt,
    isKeyBackward: _t
  }, a), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, u, l = function(c, s, f) {
    return c && c[s] !== void 0 ? c[s] : i[f || s];
  }, d = function(c, s) {
    var f = typeof (s == null ? void 0 : s.composedPath) == "function" ? s.composedPath() : void 0;
    return o.containerGroups.findIndex(function(y) {
      var m = y.container, T = y.tabbableNodes;
      return m.contains(c) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (f == null ? void 0 : f.includes(m)) || T.find(function(F) {
        return F === c;
      });
    });
  }, p = function(c) {
    var s = i[c];
    if (typeof s == "function") {
      for (var f = arguments.length, y = new Array(f > 1 ? f - 1 : 0), m = 1; m < f; m++)
        y[m - 1] = arguments[m];
      s = s.apply(void 0, y);
    }
    if (s === !0 && (s = void 0), !s) {
      if (s === void 0 || s === !1)
        return s;
      throw new Error("`".concat(c, "` was specified but was not a node, or did not return a node"));
    }
    var T = s;
    if (typeof s == "string" && (T = r.querySelector(s), !T))
      throw new Error("`".concat(c, "` as selector refers to no known node"));
    return T;
  }, b = function() {
    var c = p("initialFocus");
    if (c === !1)
      return !1;
    if (c === void 0 || !pe(c, i.tabbableOptions))
      if (d(r.activeElement) >= 0)
        c = r.activeElement;
      else {
        var s = o.tabbableGroups[0], f = s && s.firstTabbableNode;
        c = f || p("fallbackFocus");
      }
    if (!c)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return c;
  }, h = function() {
    if (o.containerGroups = o.containers.map(function(c) {
      var s = at(c, i.tabbableOptions), f = ot(c, i.tabbableOptions), y = s.length > 0 ? s[0] : void 0, m = s.length > 0 ? s[s.length - 1] : void 0, T = f.find(function(D) {
        return Y(D);
      }), F = f.slice().reverse().find(function(D) {
        return Y(D);
      }), O = !!s.find(function(D) {
        return te(D) > 0;
      });
      return {
        container: c,
        tabbableNodes: s,
        focusableNodes: f,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: O,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: y,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: m,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: T,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: F,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(I) {
          var B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, x = s.indexOf(I);
          return x < 0 ? B ? f.slice(f.indexOf(I) + 1).find(function(_) {
            return Y(_);
          }) : f.slice(0, f.indexOf(I)).reverse().find(function(_) {
            return Y(_);
          }) : s[x + (B ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(c) {
      return c.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !p("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(c) {
      return c.posTabIndexesFound;
    }) && o.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, E = function g(c) {
    var s = c.activeElement;
    if (s)
      return s.shadowRoot && s.shadowRoot.activeElement !== null ? g(s.shadowRoot) : s;
  }, w = function g(c) {
    if (c !== !1 && c !== E(document)) {
      if (!c || !c.focus) {
        g(b());
        return;
      }
      c.focus({
        preventScroll: !!i.preventScroll
      }), o.mostRecentlyFocusedNode = c, jt(c) && c.select();
    }
  }, P = function(c) {
    var s = p("setReturnFocus", c);
    return s || (s === !1 ? !1 : c);
  }, L = function(c) {
    var s = c.target, f = c.event, y = c.isBackward, m = y === void 0 ? !1 : y;
    s = s || se(f), h();
    var T = null;
    if (o.tabbableGroups.length > 0) {
      var F = d(s, f), O = F >= 0 ? o.containerGroups[F] : void 0;
      if (F < 0)
        m ? T = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : T = o.tabbableGroups[0].firstTabbableNode;
      else if (m) {
        var D = Ne(o.tabbableGroups, function(W) {
          var Q = W.firstTabbableNode;
          return s === Q;
        });
        if (D < 0 && (O.container === s || pe(s, i.tabbableOptions) && !Y(s, i.tabbableOptions) && !O.nextTabbableNode(s, !1)) && (D = F), D >= 0) {
          var I = D === 0 ? o.tabbableGroups.length - 1 : D - 1, B = o.tabbableGroups[I];
          T = te(s) >= 0 ? B.lastTabbableNode : B.lastDomTabbableNode;
        } else oe(f) || (T = O.nextTabbableNode(s, !1));
      } else {
        var x = Ne(o.tabbableGroups, function(W) {
          var Q = W.lastTabbableNode;
          return s === Q;
        });
        if (x < 0 && (O.container === s || pe(s, i.tabbableOptions) && !Y(s, i.tabbableOptions) && !O.nextTabbableNode(s)) && (x = F), x >= 0) {
          var _ = x === o.tabbableGroups.length - 1 ? 0 : x + 1, z = o.tabbableGroups[_];
          T = te(s) >= 0 ? z.firstTabbableNode : z.firstDomTabbableNode;
        } else oe(f) || (T = O.nextTabbableNode(s));
      }
    } else
      T = p("fallbackFocus");
    return T;
  }, C = function(c) {
    var s = se(c);
    if (!(d(s, c) >= 0)) {
      if (ne(i.clickOutsideDeactivates, c)) {
        u.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      ne(i.allowOutsideClick, c) || c.preventDefault();
    }
  }, V = function(c) {
    var s = se(c), f = d(s, c) >= 0;
    if (f || s instanceof Document)
      f && (o.mostRecentlyFocusedNode = s);
    else {
      c.stopImmediatePropagation();
      var y, m = !0;
      if (o.mostRecentlyFocusedNode)
        if (te(o.mostRecentlyFocusedNode) > 0) {
          var T = d(o.mostRecentlyFocusedNode), F = o.containerGroups[T].tabbableNodes;
          if (F.length > 0) {
            var O = F.findIndex(function(D) {
              return D === o.mostRecentlyFocusedNode;
            });
            O >= 0 && (i.isKeyForward(o.recentNavEvent) ? O + 1 < F.length && (y = F[O + 1], m = !1) : O - 1 >= 0 && (y = F[O - 1], m = !1));
          }
        } else
          o.containerGroups.some(function(D) {
            return D.tabbableNodes.some(function(I) {
              return te(I) > 0;
            });
          }) || (m = !1);
      else
        m = !1;
      m && (y = L({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: o.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(o.recentNavEvent)
      })), w(y || o.mostRecentlyFocusedNode || b());
    }
    o.recentNavEvent = void 0;
  }, K = function(c) {
    var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = c;
    var f = L({
      event: c,
      isBackward: s
    });
    f && (oe(c) && c.preventDefault(), w(f));
  }, H = function(c) {
    if (Vt(c) && ne(i.escapeDeactivates, c) !== !1) {
      c.preventDefault(), u.deactivate();
      return;
    }
    (i.isKeyForward(c) || i.isKeyBackward(c)) && K(c, i.isKeyBackward(c));
  }, Z = function(c) {
    var s = se(c);
    d(s, c) >= 0 || ne(i.clickOutsideDeactivates, c) || ne(i.allowOutsideClick, c) || (c.preventDefault(), c.stopImmediatePropagation());
  }, q = function() {
    if (o.active)
      return Le.activateTrap(n, u), o.delayInitialFocusTimer = i.delayInitialFocus ? xe(function() {
        w(b());
      }) : w(b()), r.addEventListener("focusin", V, !0), r.addEventListener("mousedown", C, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", C, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", Z, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", H, {
        capture: !0,
        passive: !1
      }), u;
  }, N = function() {
    if (o.active)
      return r.removeEventListener("focusin", V, !0), r.removeEventListener("mousedown", C, !0), r.removeEventListener("touchstart", C, !0), r.removeEventListener("click", Z, !0), r.removeEventListener("keydown", H, !0), u;
  }, M = function(c) {
    var s = c.some(function(f) {
      var y = Array.from(f.removedNodes);
      return y.some(function(m) {
        return m === o.mostRecentlyFocusedNode;
      });
    });
    s && w(b());
  }, A = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(M) : void 0, R = function() {
    A && (A.disconnect(), o.active && !o.paused && o.containers.map(function(c) {
      A.observe(c, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return u = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(c) {
      if (o.active)
        return this;
      var s = l(c, "onActivate"), f = l(c, "onPostActivate"), y = l(c, "checkCanFocusTrap");
      y || h(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = r.activeElement, s == null || s();
      var m = function() {
        y && h(), q(), R(), f == null || f();
      };
      return y ? (y(o.containers.concat()).then(m, m), this) : (m(), this);
    },
    deactivate: function(c) {
      if (!o.active)
        return this;
      var s = Ce({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, c);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, N(), o.active = !1, o.paused = !1, R(), Le.deactivateTrap(n, u);
      var f = l(s, "onDeactivate"), y = l(s, "onPostDeactivate"), m = l(s, "checkCanReturnFocus"), T = l(s, "returnFocus", "returnFocusOnDeactivate");
      f == null || f();
      var F = function() {
        xe(function() {
          T && w(P(o.nodeFocusedBeforeActivation)), y == null || y();
        });
      };
      return T && m ? (m(P(o.nodeFocusedBeforeActivation)).then(F, F), this) : (F(), this);
    },
    pause: function(c) {
      if (o.paused || !o.active)
        return this;
      var s = l(c, "onPause"), f = l(c, "onPostPause");
      return o.paused = !0, s == null || s(), N(), R(), f == null || f(), this;
    },
    unpause: function(c) {
      if (!o.paused || !o.active)
        return this;
      var s = l(c, "onUnpause"), f = l(c, "onPostUnpause");
      return o.paused = !1, s == null || s(), h(), q(), R(), f == null || f(), this;
    },
    updateContainerElements: function(c) {
      var s = [].concat(c).filter(Boolean);
      return o.containers = s.map(function(f) {
        return typeof f == "string" ? r.querySelector(f) : f;
      }), o.active && h(), R(), this;
    }
  }, u.updateContainerElements(e), u;
};
const $t = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: Kt
}, Symbol.toStringTag, { value: "Module" })), Ht = /* @__PURE__ */ Me($t), Zt = /* @__PURE__ */ Me(it);
function J(t) {
  "@babel/helpers - typeof";
  return J = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, J(t);
}
function Ut(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Gt(t, e) {
  for (var a = 0; a < e.length; a++) {
    var r = e[a];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, _e(r.key), r);
  }
}
function qt(t, e, a) {
  return e && Gt(t.prototype, e), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function zt(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && me(t, e);
}
function me(t, e) {
  return me = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, n) {
    return r.__proto__ = n, r;
  }, me(t, e);
}
function Wt(t) {
  var e = Yt();
  return function() {
    var r = le(t), n;
    if (e) {
      var i = le(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else
      n = r.apply(this, arguments);
    return Qt(this, n);
  };
}
function Qt(t, e) {
  if (e && (J(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return ae(t);
}
function ae(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function Yt() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function le(t) {
  return le = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, le(t);
}
function Jt(t, e, a) {
  return e = _e(e), e in t ? Object.defineProperty(t, e, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = a, t;
}
function _e(t) {
  var e = Xt(t, "string");
  return J(e) === "symbol" ? e : String(e);
}
function Xt(t, e) {
  if (J(t) !== "object" || t === null) return t;
  var a = t[Symbol.toPrimitive];
  if (a !== void 0) {
    var r = a.call(t, e || "default");
    if (J(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var ce = Qe, v = vt, en = Ht, tn = en.createFocusTrap, nn = Zt, rn = nn.isFocusable, ye = /* @__PURE__ */ function(t) {
  zt(a, t);
  var e = Wt(a);
  function a(r) {
    var n;
    Ut(this, a), n = e.call(this, r), Jt(ae(n), "getNodeForOption", function(u) {
      var l, d = (l = this.internalOptions[u]) !== null && l !== void 0 ? l : this.originalOptions[u];
      if (typeof d == "function") {
        for (var p = arguments.length, b = new Array(p > 1 ? p - 1 : 0), h = 1; h < p; h++)
          b[h - 1] = arguments[h];
        d = d.apply(void 0, b);
      }
      if (d === !0 && (d = void 0), !d) {
        if (d === void 0 || d === !1)
          return d;
        throw new Error("`".concat(u, "` was specified but was not a node, or did not return a node"));
      }
      var E = d;
      if (typeof d == "string") {
        var w;
        if (E = (w = this.getDocument()) === null || w === void 0 ? void 0 : w.querySelector(d), !E)
          throw new Error("`".concat(u, "` as selector refers to no known node"));
      }
      return E;
    }), n.handleDeactivate = n.handleDeactivate.bind(ae(n)), n.handlePostDeactivate = n.handlePostDeactivate.bind(ae(n)), n.handleClickOutsideDeactivates = n.handleClickOutsideDeactivates.bind(ae(n)), n.internalOptions = {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      returnFocusOnDeactivate: !1,
      // the rest of these are also related to deactivation of the trap, and we
      //  need to use them and control them as well
      checkCanReturnFocus: null,
      onDeactivate: n.handleDeactivate,
      onPostDeactivate: n.handlePostDeactivate,
      // we need to special-case this setting as well so that we can know if we should
      //  NOT return focus if the trap gets auto-deactivated as the result of an
      //  outside click (otherwise, we'll always think we should return focus because
      //  of how we manage that flag internally here)
      clickOutsideDeactivates: n.handleClickOutsideDeactivates
    }, n.originalOptions = {
      // because of the above `internalOptions`, we maintain our own flag for
      //  this option, and default it to `true` because that's focus-trap's default
      returnFocusOnDeactivate: !0,
      // because of the above `internalOptions`, we keep these separate since
      //  they're part of the deactivation process which we configure (internally) to
      //  be shared between focus-trap and focus-trap-react
      onDeactivate: null,
      onPostDeactivate: null,
      checkCanReturnFocus: null,
      // the user's setting, defaulted to false since focus-trap defaults this to false
      clickOutsideDeactivates: !1
    };
    var i = r.focusTrapOptions;
    for (var o in i)
      if (Object.prototype.hasOwnProperty.call(i, o)) {
        if (o === "returnFocusOnDeactivate" || o === "onDeactivate" || o === "onPostDeactivate" || o === "checkCanReturnFocus" || o === "clickOutsideDeactivates") {
          n.originalOptions[o] = i[o];
          continue;
        }
        n.internalOptions[o] = i[o];
      }
    return n.outsideClick = null, n.focusTrapElements = r.containerElements || [], n.updatePreviousElement(), n;
  }
  return qt(a, [{
    key: "getDocument",
    value: function() {
      return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
    }
  }, {
    key: "getReturnFocusNode",
    value: function() {
      var n = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
      return n || (n === !1 ? !1 : this.previouslyFocusedElement);
    }
    /** Update the previously focused element with the currently focused element. */
  }, {
    key: "updatePreviousElement",
    value: function() {
      var n = this.getDocument();
      n && (this.previouslyFocusedElement = n.activeElement);
    }
  }, {
    key: "deactivateTrap",
    value: function() {
      !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
        // NOTE: we never let the trap return the focus since we do that ourselves
        returnFocus: !1,
        // we'll call this in our own post deactivate handler so make sure the trap doesn't
        //  do it prematurely
        checkCanReturnFocus: null,
        // let it call the user's original deactivate handler, if any, instead of
        //  our own which calls back into this function
        onDeactivate: this.originalOptions.onDeactivate
        // NOTE: for post deactivate, don't specify anything so that it calls the
        //  onPostDeactivate handler specified on `this.internalOptions`
        //  which will always be our own `handlePostDeactivate()` handler, which
        //  will finish things off by calling the user's provided onPostDeactivate
        //  handler, if any, at the right time
        // onPostDeactivate: NOTHING
      });
    }
  }, {
    key: "handleClickOutsideDeactivates",
    value: function(n) {
      var i = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, n) : this.originalOptions.clickOutsideDeactivates;
      return i && (this.outsideClick = {
        target: n.target,
        allowDeactivation: i
      }), i;
    }
  }, {
    key: "handleDeactivate",
    value: function() {
      this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
    }
  }, {
    key: "handlePostDeactivate",
    value: function() {
      var n = this, i = function() {
        var u = n.getReturnFocusNode(), l = !!// did the consumer allow it?
        (n.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
        u !== null && u !== void 0 && u.focus && // was there an outside click that allowed deactivation?
        (!n.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
        n.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
        //  as a result of the click-through) -- in which case do NOT restore focus
        //  to `returnFocusNode` because focus should remain on the outside node
        !rn(n.outsideClick.target, n.internalOptions.tabbableOptions))), d = n.internalOptions.preventScroll, p = d === void 0 ? !1 : d;
        l && u.focus({
          preventScroll: p
        }), n.originalOptions.onPostDeactivate && n.originalOptions.onPostDeactivate.call(null), n.outsideClick = null;
      };
      this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(i, i) : i();
    }
  }, {
    key: "setupFocusTrap",
    value: function() {
      if (this.focusTrap)
        this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      else {
        var n = this.focusTrapElements.some(Boolean);
        n && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
      }
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.props.active && this.setupFocusTrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      if (this.focusTrap) {
        n.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
        var i = !n.active && this.props.active, o = n.active && !this.props.active, u = !n.paused && this.props.paused, l = n.paused && !this.props.paused;
        if (i && (this.updatePreviousElement(), this.focusTrap.activate()), o) {
          this.deactivateTrap();
          return;
        }
        u && this.focusTrap.pause(), l && this.focusTrap.unpause();
      } else
        n.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function() {
      var n = this, i = this.props.children ? ce.Children.only(this.props.children) : void 0;
      if (i) {
        if (i.type && i.type === ce.Fragment)
          throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
        var o = function(d) {
          var p = n.props.containerElements;
          i && (typeof i.ref == "function" ? i.ref(d) : i.ref && (i.ref.current = d)), n.focusTrapElements = p || [d];
        }, u = ce.cloneElement(i, {
          ref: o
        });
        return u;
      }
      return null;
    }
  }]), a;
}(ce.Component), re = typeof Element > "u" ? Function : Element;
ye.propTypes = {
  active: v.bool,
  paused: v.bool,
  focusTrapOptions: v.shape({
    document: v.object,
    onActivate: v.func,
    onPostActivate: v.func,
    checkCanFocusTrap: v.func,
    onPause: v.func,
    onPostPause: v.func,
    onUnpause: v.func,
    onPostUnpause: v.func,
    onDeactivate: v.func,
    onPostDeactivate: v.func,
    checkCanReturnFocus: v.func,
    initialFocus: v.oneOfType([v.instanceOf(re), v.string, v.bool, v.func]),
    fallbackFocus: v.oneOfType([
      v.instanceOf(re),
      v.string,
      // NOTE: does not support `false` as value (or return value from function)
      v.func
    ]),
    escapeDeactivates: v.oneOfType([v.bool, v.func]),
    clickOutsideDeactivates: v.oneOfType([v.bool, v.func]),
    returnFocusOnDeactivate: v.bool,
    setReturnFocus: v.oneOfType([v.instanceOf(re), v.string, v.bool, v.func]),
    allowOutsideClick: v.oneOfType([v.bool, v.func]),
    preventScroll: v.bool,
    tabbableOptions: v.shape({
      displayCheck: v.oneOf(["full", "legacy-full", "non-zero-area", "none"]),
      getShadowRoot: v.oneOfType([v.bool, v.func])
    }),
    trapStack: v.array,
    isKeyForward: v.func,
    isKeyBackward: v.func
  }),
  containerElements: v.arrayOf(v.instanceOf(re)),
  // DOM element ONLY
  children: v.oneOfType([
    v.element,
    // React element
    v.instanceOf(re)
    // DOM element
  ])
  // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.
};
ye.defaultProps = {
  active: !0,
  paused: !1,
  focusTrapOptions: {},
  _createFocusTrap: tn
};
var an = ye;
const Fn = /* @__PURE__ */ dt(an);
export {
  Fn as F,
  wn as I,
  Be as g,
  gn as i
};
//# sourceMappingURL=focus-trap-react-CzdCUkYc.mjs.map
